import React from 'react';
import { Eyebrow, SectionLead, SectionTitle } from './ui/Section';
const week = [['Lun', 'Running', '4K suave'], ['Mar', 'Fuerza', '30 min'], ['Mié', 'Descanso', '—'], ['Jue', 'Intervalos', '6 × 400m'], ['Vie', 'Técnica', '15 min'], ['Sáb', 'Descanso', '—'], ['Dom', 'Tirada larga', '8K']] as const;
const session = [['Calentamiento', '10 min', 'Trote suave + movilidad'], ['Serie 1', '6 × 400m', 'Ritmo 10K · 90" descanso'], ['Vuelta a la calma', '8 min', 'Trote muy suave']] as const;
const strength = [['Sentadilla', '3 × 12', '60"'], ['Zancadas', '3 × 10', '60"'], ['Puente de glúteo', '3 × 15', '45"'], ['Plancha', '3 × 40"', '45"']] as const;
const record = [['Nivel actual', '5K'], ['Objetivo', '10K'], ['Semana', '4 de 10'], ['RPE promedio', '6 / 10']] as const;
const progression = ['1K', '3K', '4K', '5K', '8K', '10K', '15K', '21K'];
const groupClass = [['Principiantes', 'Trote / caminata 20 min'], ['Grupo 5K', 'Rodaje continuo 5K'], ['Grupo 10K', 'Intervalos 5 × 1000m'], ['Grupo 21K', 'Tirada larga 14K']] as const;
function PreviewCard({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <article className="flex flex-col rounded-2xl border border-line bg-white p-5 shadow-sm" data-id="element-150" data-mp="3c08eomk3wzni">
      <h3 className="text-sm font-black uppercase tracking-wide text-ink md:text-base" data-id="element-151" data-mp="3gyjpazi87e6s">{title}</h3>
      <div className="mt-4 flex-1" data-id="element-152" data-mp="32za7jvedgc0p">{children}</div>
    </article>;
}
export function InsidePreview() {
  return <section className="border-y border-line bg-white px-4 py-12 md:py-14" data-id="element-153" data-mp="370vsm4127wlz">
      <div className="mx-auto max-w-6xl" data-id="element-154" data-mp="2t1477i87rdxy">
        <Eyebrow data-id="element-155" data-mp="2t25tyjyldovi">🔍 Vista por dentro</Eyebrow>
        <SectionTitle data-id="element-156" data-mp="2xzxnfievxj1t">¿Qué vas a encontrar adentro?</SectionTitle>
        <SectionLead data-id="element-157" data-mp="2y0h28q98nrbm">
          Ejemplos del tipo de material que recibís: planificaciones, sesiones, rutinas y fichas
          listas para usar.
        </SectionLead>

        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-158" data-mp="w7j7govwioo1">
          <PreviewCard title="📅 Calendario semanal" data-id="element-159" data-mp="ur5ftxflbjkk">
            <table className="w-full text-left text-xs font-semibold text-slate-600 md:text-sm" data-id="element-160" data-mp="usq97jq64wgu">
              <tbody data-id="element-161" data-mp="pqr7sfdzo9mj">
                {week.map(([day, type, detail]) => <tr key={day} className="border-b border-line last:border-b-0" data-id="element-162" data-mp="kuak1mapbx9z">
                    <th scope="row" className="py-1.5 pr-2 font-black uppercase text-primary" data-id="element-163" data-mp="fuxw0y83gk5t">
                      {day}
                    </th>
                    <td className="py-1.5 pr-2" data-id="element-164" data-mp="1djzj3u3upn8y">{type}</td>
                    <td className="py-1.5 text-right font-bold text-ink" data-id="element-165" data-mp="18jv1g0r7imh5">{detail}</td>
                  </tr>)}
              </tbody>
            </table>
          </PreviewCard>

          <PreviewCard title="⏱️ Sesión de running" data-id="element-166" data-mp="ytsbk9fdton1">
            <ul className="space-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-167" data-mp="yqxpyekmtxs1">
              {session.map(([block, load, detail]) => <li key={block} className="rounded-lg bg-canvas p-3" data-id="element-168" data-mp="1rhfpj5m5dh0p">
                  <div className="flex items-center justify-between gap-2" data-id="element-169" data-mp="1zqbsc0o5k6oi">
                    <span className="font-black uppercase text-ink" data-id="element-170" data-mp="1zserpbb73c5w">{block}</span>
                    <span className="font-black text-accent" data-id="element-171" data-mp="23sfd5fwponmg">{load}</span>
                  </div>
                  <p className="mt-0.5" data-id="element-172" data-mp="28pfbt5r8eo3j">{detail}</p>
                </li>)}
            </ul>
          </PreviewCard>

          <PreviewCard title="💪 Rutina de fuerza" data-id="element-173" data-mp="2dnql9fdm6wl8">
            <table className="w-full text-left text-xs font-semibold text-slate-600 md:text-sm" data-id="element-174" data-mp="2io4qkpntzsfk">
              <thead data-id="element-175" data-mp="2mpq3uc4a28qa">
                <tr className="border-b border-line text-[10px] uppercase tracking-wide text-slate-400" data-id="element-176" data-mp="2moyhzt0hfpd7">
                  <th scope="col" className="pb-1.5" data-id="element-177" data-mp="2ri9oft1du44l">
                    Ejercicio
                  </th>
                  <th scope="col" className="pb-1.5 text-center" data-id="element-178" data-mp="2wip0mh9xh5kz">
                    Series
                  </th>
                  <th scope="col" className="pb-1.5 text-right" data-id="element-179" data-mp="36es3xqgina9i">
                    Descanso
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-180" data-mp="6z6ql1mle7i3">
                {strength.map(([exercise, sets, rest]) => <tr key={exercise} className="border-b border-line last:border-b-0" data-id="element-181" data-mp="20n0qq4vobkg">
                    <td className="py-1.5 font-bold text-ink" data-id="element-182" data-mp="gqudqqc492dr">{exercise}</td>
                    <td className="py-1.5 text-center" data-id="element-183" data-mp="brq5q30xhap0">{sets}</td>
                    <td className="py-1.5 text-right" data-id="element-184" data-mp="btkq9g8af0sk">{rest}</td>
                  </tr>)}
              </tbody>
            </table>
          </PreviewCard>

          <PreviewCard title="📋 Ficha de alumno" data-id="element-185" data-mp="3f9i2duq0eitj">
            <dl className="space-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-186" data-mp="3t7znrlsfzj8a">
              {record.map(([label, value]) => <div key={label} className="flex items-center justify-between gap-2 border-b border-line pb-2 last:border-b-0 last:pb-0" data-id="element-187" data-mp="3p5ban1wp3q5i">
                  <dt data-id="element-188" data-mp="14gx0qs16bi5i">{label}</dt>
                  <dd className="font-black text-ink" data-id="element-189" data-mp="14fvquqvw91pd">{value}</dd>
                </div>)}
            </dl>
          </PreviewCard>

          <PreviewCard title="📈 Plan de progresión" data-id="element-190" data-mp="1gyhnv733ibi2">
            <div className="flex flex-wrap items-end gap-1.5" data-id="element-191" data-mp="1h02fooy0zgc8">
              {progression.map((step, index) => <span key={step} className="rounded-md px-2 py-1 text-xs font-black text-white md:text-sm" style={{
              backgroundColor: '#0B2038',
              opacity: 0.55 + index * 0.06
            }} data-id="element-192" data-mp="123l35ue3nvo3" data-mpi={index}>
                  {step}
                </span>)}
            </div>
            <p className="mt-4 text-xs font-semibold leading-snug text-slate-600 md:text-sm" data-id="element-193" data-mp="1l02wuhcie5mz">
              Cada bloque indica cuándo repetir la semana y cuándo avanzar al siguiente objetivo.
            </p>
          </PreviewCard>

          <PreviewCard title="👥 Clase grupal" data-id="element-194" data-mp="2ifgpfvp8v7xv">
            <ul className="space-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-195" data-mp="2ihbb5c8cb430">
              {groupClass.map(([level, work]) => <li key={level} className="flex items-center justify-between gap-2 rounded-lg bg-canvas p-2.5" data-id="element-196" data-mp="2ncmf1hdrh1lj">
                  <span className="font-black uppercase text-primary" data-id="element-197" data-mp="2jasi9k6oshqn">{level}</span>
                  <span className="text-right" data-id="element-198" data-mp="2eby1ensa5396">{work}</span>
                </li>)}
            </ul>
          </PreviewCard>
        </div>
      </div>
    </section>;
}